export class ArrayUtils {

    public static remove<T>(array: Array<T>, itemToRemove: T) {
        array.splice(array.indexOf(itemToRemove), 1);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/utils/array.utils.ts